import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createService } from "../../api/apiServices";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useCreateService = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createServiceMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: createService,
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/services');
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create service");
        },
    });

    return {
        createServiceMutate,
        isPending: isPending || isLoading,
    };
};

export default useCreateService;
